module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Application data","acceptTerms":"Application terms"},"et":{"title":"Application data","acceptTerms":"Application terms"},"ru":{"title":"Application data","acceptTerms":"Application terms"}}')
  delete Component.options._Ctor
}
